import React from 'react';
import './HomePrivacyPopup.css';

class HomePrivacyPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: false,
            isClosing: false,
            dontShowAgain: false
        };
        this.storageKey = 'home_privacy_notice_dont_show_again';
    }

    componentDidMount() {
        // Auto-show popup after component mounts if not previously dismissed
        if (!this.shouldNotShow()) {
            setTimeout(() => {
                this.show();
            }, 500);
        }

        // Setup event listeners
        this.setupEventListeners();
    }

    componentWillUnmount() {
        this.removeEventListeners();
    }

    setupEventListeners = () => {
        // Close popup with ESC key
        document.addEventListener('keydown', this.handleKeyDown);
    }

    removeEventListeners = () => {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown = (e) => {
        if (e.key === 'Escape' && this.state.isVisible) {
            this.close();
        }
    }

    shouldNotShow = () => {
        return localStorage.getItem(this.storageKey) === 'true';
    }

    setDontShowAgain = () => {
        localStorage.setItem(this.storageKey, 'true');
    }

    show = () => {
        if (this.shouldNotShow()) {
            return false;
        }

        this.setState({
            isVisible: true,
            isClosing: false
        });

        // Prevent body scrolling
        document.body.style.overflow = 'hidden';

        return true;
    }

    close = () => {
        if (!this.state.isVisible) return;

        // Check "don't show again" option
        if (this.state.dontShowAgain) {
            this.setDontShowAgain();
        }

        // Animate close
        this.setState({ isClosing: true });

        setTimeout(() => {
            this.setState({
                isVisible: false,
                isClosing: false
            });

            // Restore body scrolling
            document.body.style.overflow = '';
        }, 300);
    }

    handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            this.close();
        }
    }

    handleDontShowAgain = () => {
        this.setDontShowAgain();
        this.close();
    }

    handleDetailView = () => {
        window.open('./noti-privacy-transfer', '_blank');
    }

    // Force show (for testing or admin override)
    forceShow = () => {
        this.setState({
            isVisible: true,
            isClosing: false
        });
        document.body.style.overflow = 'hidden';
    }

    // Clear "don't show again" setting
    clearDontShowAgain = () => {
        localStorage.removeItem(this.storageKey);
    }

    render() {
        if (!this.state.isVisible) {
            return null;
        }

        return (
            <div
                className={`home-privacy-popup ${this.state.isClosing ? 'closing' : ''}`}
                onClick={this.handleBackdropClick}
            >
                <div className="home-privacy-popup-inner">
                    <div className="privacy-popup-header">
                        <h2>사명 변경 안내</h2>
                        <button
                            className="close-x-btn"
                            onClick={this.close}
                            aria-label="팝업 닫기"
                        >
                            ×
                        </button>
                    </div>

                    <div className="privacy-popup-content">
                        <p className="greeting-text">
                            안녕하세요. 9.81파크입니다.<br />
                            '(주)대성파인텍'이 '(주)디에스엠'으로<br />
                            변경되어 안내드립니다.
                        </p>

                        <div className="privacy-info-box">
                            <ul>
                                <li>변경 일자 : 2026.03.26</li>
                                <li>변경사항 : 사명변경 (주)대성파인텍 → (주)디에스엠</li>
                            </ul>
                        </div>

                        <p className="contact-info">
                            앞으로도 더 나은 서비스를 제공하기 위해 노력하겠습니다.<br />
                            (주)디에스엠 대표이사 김종석<br /><br />
                            <a className="contact-info" href="https://dsmcorporation.com"><u>디에스엠 홈페이지 바로가기 ></u></a>
                        </p>
                    </div>

                    <div className="privacy-popup-buttons">
                        <button
                            className="dont-show-btn"
                            onClick={this.handleDontShowAgain}
                        >
                            다시 보지 않기
                        </button>
                        <button
                            className="close-btn"
                            onClick={this.close}
                        >
                            닫기
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default HomePrivacyPopup;